"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetCopy = exports.replaceTemplateVariables = void 0;

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.concat.js");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var faqLinkElement = '<div class="zola-text faq-link">Having trouble uploading photos? Check out our <a href="https://help.zola.com/hc/en-us/articles/360052051352-How-do-I-upload-photos-to-my-paper-products-" target="_blank">FAQs</a> or reach out at <a href="mailto:support@zola.com" target="_blank">support@zola.com</a></div>';
// Upload care uses locale objects that contain the text it displays in its components. The full list of values you can override can be found here: https://github.com/uploadcare/uploadcare-widget/blob/master/src/locales/en.js
var DEFAULT_COPY = {
  uploading: "Hang tight! We're uploading your photos...",
  errors: {
    dimensions: 'Images must be at least {minDimensionsCopy}.',
    size: 'Images must be under {maxSize}MB',
    fileType: 'Images must be {fileTypeCopy} files',
    image: 'Images must be {fileTypeCopy} files',
    user: "Please upload no more than {maxFileCount} images at once"
  },
  dialog: {
    tabs: {
      file: {
        drag: 'Drag & drop here',
        or: 'or',
        button: 'Upload Your Files<span class="zola-text file-info">{fileRequirementsCopy}</span>'
      },
      names: {
        file: 'Your Files'
      },
      preview: {
        done: 'Save',
        error: {
          dimensions: {
            title: 'Looks like your photo is too small...',
            text: "Images must be at least {minDimensionsCopy}.".concat(faqLinkElement),
            back: 'Select Another Photo'
          },
          size: {
            title: 'Looks like your photo is too big...',
            text: "Images must be under {maxSize}MB".concat(faqLinkElement),
            back: 'Select Another Photo'
          },
          image: {
            title: 'Your selected file type cannot be uploaded…',
            text: "Images must be {fileTypeCopy} files".concat(faqLinkElement),
            back: 'Select Another Photo'
          }
        },
        image: {
          title: 'Edit Photo'
        },
        unknown: {
          title: "Hang tight! We're uploading your photos..."
        },
        multiple: {
          tooManyFiles: 'What beautiful photos! Please upload no more than {maxFileCount} at a time.'
        }
      }
    }
  }
};
var EDITING_ONLY_COPY = {
  buttons: {
    cancel: 'Reset'
  },
  dialog: {
    tabs: {
      preview: {
        change: 'Reset',
        image: {
          title: 'Edit image',
          change: 'Reset'
        },
        error: {
          dimensions: {
            title: 'Looks like your photo is too small...',
            text: "Images must be at least {minDimensionsCopy}.".concat(faqLinkElement),
            back: 'Select Another Photo'
          },
          size: {
            title: 'Looks like your photo is too big...',
            text: "Images must be under {maxSize}MB".concat(faqLinkElement),
            back: 'Select Another Photo'
          },
          image: {
            title: 'Your selected file type cannot be uploaded…',
            text: "Images must be {fileTypeCopy} files".concat(faqLinkElement),
            back: 'Select Another Photo'
          }
        }
      }
    }
  }
};
var FILE_TYPE_COPY = {
  'image/jpeg': 'JPG',
  'image/png': 'PNG',
  'image/gif': 'GIF',
  'image/svg+xml': 'SVG',
  'image/tiff': 'TIFF',
  'image/webp': 'WEBP',
  'image/bmp': 'Bitmap'
};

/**
 * Recursively formats all strings contained in an object, replacing template
 * variables (in curly braces) with their corresponding values (if available).
 * @param {(Object)} currentNode - A translation object. Strings can contain template variables in curly braces
 * @param {Object} replacements - An object with properties for each template variable to replace
 * @returns {(Object)} - A formatted version of currentNode
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var replaceTemplateVariables = function replaceTemplateVariables(currentNode, replacements) {
  if (typeof currentNode === 'string') {
    var formatted = currentNode;
    Object.keys(replacements).forEach(function (key) {
      formatted = formatted.replace("{".concat(key, "}"), replacements[key]);
    });
    return formatted;
  }

  var newNode = {};
  Object.keys(currentNode).forEach(function (key) {
    newNode[key] = replaceTemplateVariables(currentNode[key], replacements);
  });
  return newNode;
};

exports.replaceTemplateVariables = replaceTemplateVariables;

var getMinDimensionsCopy = function getMinDimensionsCopy(_ref) {
  var minDimension = _ref.minDimension,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight;
  var minDimensionsTemplate = '';

  if (minDimension) {
    minDimensionsTemplate = '{minDimension}px wide or high';
  } else if (minWidth && minHeight) {
    minDimensionsTemplate = '{minWidth} x {minHeight} pixels';
  } else if (minWidth) {
    minDimensionsTemplate = '{minWidth}px wide';
  } else if (minHeight) {
    minDimensionsTemplate = '{minHeight}px high';
  }

  return replaceTemplateVariables(minDimensionsTemplate, {
    minDimension: minDimension,
    minWidth: minWidth,
    minHeight: minHeight
  });
}; // Returns a string enumerating all accepted file types


var getFileTypeCopy = function getFileTypeCopy(_ref2) {
  var _ref2$inputAcceptType = _ref2.inputAcceptTypes,
      inputAcceptTypes = _ref2$inputAcceptType === void 0 ? [] : _ref2$inputAcceptType;
  // Empty
  if (!inputAcceptTypes.length) return ''; // Map input type to copy

  var fileTypeNames = inputAcceptTypes.map(function (type) {
    var mimeType = _constants.ACCEPT_TYPE_TO_MIME_TYPE[type][0];
    return FILE_TYPE_COPY[mimeType];
  }); // Single

  if (inputAcceptTypes.length === 1) return fileTypeNames[0]; // Multiples. Insert a comma between every item except the last, which uses the word "or".

  var allButLast = fileTypeNames.slice(0, -1);
  var last = fileTypeNames.slice(-1);
  return [allButLast.join(', ')].concat(_toConsumableArray(last)).join(' or ');
};

var getFileRequirementsCopy = function getFileRequirementsCopy(_ref3, minDimensionsCopy, fileTypeCopy) {
  var maxSize = _ref3.maxSize;
  if (!maxSize && !minDimensionsCopy && !fileTypeCopy) return '';
  var fileRequirementsTemplate = minDimensionsCopy ? 'Images ({fileTypeCopy}) must be at least<br>{minDimensionsCopy} and under {maxSize}MB each.' : 'Images ({fileTypeCopy}) must be under {maxSize}MB each.';
  return replaceTemplateVariables(fileRequirementsTemplate, {
    maxSize: maxSize,
    minDimensionsCopy: minDimensionsCopy,
    fileTypeCopy: fileTypeCopy
  });
};

var getWidgetCopy = function getWidgetCopy(values, isEditOnly) {
  var minDimensionsCopy = getMinDimensionsCopy(values);
  var fileTypeCopy = getFileTypeCopy(values);
  var fileRequirementsCopy = getFileRequirementsCopy(values, minDimensionsCopy, fileTypeCopy);
  return replaceTemplateVariables(isEditOnly ? EDITING_ONLY_COPY : DEFAULT_COPY, _objectSpread(_objectSpread({}, values), {}, {
    minDimensionsCopy: minDimensionsCopy,
    fileTypeCopy: fileTypeCopy,
    fileRequirementsCopy: fileRequirementsCopy
  }));
};

exports.getWidgetCopy = getWidgetCopy;